import { BackOfficeCommentsTable } from "../../BackOfficeCommentsTable";
import { BackOfficeStopDetails } from "../../BackOfficeStopDetails";
import { Button, Checkbox, DataHeader, DataSource, Layout, Panel, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCommissionsHistory extends Layout {
    buttonOrderHistory: Button;
    buttonResponsibility: Button;
    buttonViewEarnings: Button;
    checkboxOverrideRate: Checkbox;
    checkboxVoided: Checkbox;
    dataheaderCommissions: DataHeader;
    layoutComments: BackOfficeCommentsTable;
    layoutImageTable: Layout;
    layoutOtherCharges: Layout;
    layoutStop: BackOfficeStopDetails;
    panelEntryInfo: Panel;
    panelGeneral: Panel;
    panelPayTotals: Panel;
    sourceComments: DataSource;
    sourceCommissionHistory: DataSource;
    sourceOrderOtherCharge: DataSource;
    sourceResponsibleHist: DataSource;
    sourceStop: DataSource;
    tabComments: Tab;
    tabCommissions: Tab;
    tabGeneral: Tab;
    tabImages: Tab;
    tabOrderMovementDetail: Tab;
    tabOtherCharges: Tab;
    tabStopDetails: Tab;
    tabsetCommission: Tabset;
    textboxAllocatedDrawAmount: Textbox;
    textboxCarrierExtraPay: Textbox;
    textboxCarrierPay: Textbox;
    textboxCommissionRole: Textbox;
    textboxCommissionableMargin: Textbox;
    textboxCommissionsSplitPercent: Textbox;
    textboxCommodityId: Textbox;
    textboxCustomerId: Textbox;
    textboxDeliveryDate: Textbox;
    textboxDestinationCity: Textbox;
    textboxDestinationState: Textbox;
    textboxEndingPayDate: Textbox;
    textboxEntryMethod: Textbox;
    textboxLinehaulCharge: Textbox;
    textboxManifestId: Textbox;
    textboxMovementId: Textbox;
    textboxNetCommissionableMargin: Textbox;
    textboxOk2payDate: Textbox;
    textboxOrderId: Textbox;
    textboxOrderType: Textbox;
    textboxOriginCity: Textbox;
    textboxOriginState: Textbox;
    textboxOtherCharges: Textbox;
    textboxPayRate: Textbox;
    textboxPayeeDrawAmount: Textbox;
    textboxPayeeId: Textbox;
    textboxRate: Textbox;
    textboxRateCode: Textbox;
    textboxRateType: Textbox;
    textboxRecurringExpense: Textbox;
    textboxRevenueId: Textbox;
    textboxShipDate: Textbox;
    textboxSplitCommMargin: Textbox;
    textboxTotalPay: Textbox;
    textboxTransferDate: Textbox;
}
